"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const theme_1 = require("../util/theme");
const GlobalStyle = styled_components_1.createGlobalStyle `
  html {
    line-height: 1.5;
    font-size: 15px;
    min-height: 100vh;
  }

  body {
    margin: 0;
    padding: 0;
    min-height: 100vh;
    font-family: 'Noto Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    background-color: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  a {
    color: ${(props) => props.theme.colors.action};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  * {
    box-sizing: border-box;
  }
`;
const Provider = ({ theme, children }) => {
    const hasLightPreferrence = react_1.useMemo(() => !window.matchMedia("(prefers-color-scheme: dark)").matches, []);
    const usedTheme = react_1.useMemo(() => {
        if (theme) {
            return theme === "light" ? theme_1.lightTheme : theme_1.darkTheme;
        }
        else {
            return hasLightPreferrence ? theme_1.lightTheme : theme_1.darkTheme;
        }
    }, [theme, hasLightPreferrence]);
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: usedTheme },
        react_1.default.createElement(GlobalStyle, null),
        children));
};
exports.default = Provider;
